import Vue from 'vue'
import Vuex from 'vuex'
import shared from './shared'
import auth from './auth'
import device from './device'
import nucleus from './nucleus'
import nucleus2 from './nucleus2'
import property from './property'
import alarms from './alarm'
import readings from './reading'
import statistics from './statistic'
import user from './user'
import sex from './sex'
import device2 from './device2'
import deviceLoginCookie from './device_login_cookie'
import deviceModel from './device_model'
import deviceType from './device_type'
import country from './country'
import state from './state'
import city from './city'
import wall from './wall'
import floor from './floor'
import roof from './roof'
import innerCurtain from './inner_curtain'
import outerCurtain from './outer_curtain'
import ownership from './ownship'
import lining from './lining'
import evaporativePlate from './evaporative_plate'
import lightingSystem from './lighting_system'
import internetAccessType from './internet_access_type'
import barn from './barn'
import barnType from './barn_type'
import voltageType from './voltage_type'
import airInlet from './air_inlet'
import siloType from './silo_type'
import waterBox from './water_box'
import watchdogSystem from './watchdog_system'
import batch from './batch'
import batchState from './batch_state'
import manufacturer from './manufacturer'
import mortality from './mortality'
import account from './account'
import readings2 from './reading2'
import statistic2 from './statistic2'
import inobramxPerformance from './inobramx_performance'
import inobramxSetpoint from './inobramx_setpoint'
import inobramxMaxMin from './inobramx_max_min'
import weightAnalysis from './weight_analysis'
import deviceRemoteAccessUrl from './device_remote_access_url'
import realtime from './realtime'
import subscriptionDevices from './subscription_device'
import version from './version'
import alarmDashboard from './alarm_dashboard'
import activeAlarms from './active_alarms'
import deviceFeatures from './device_features'
import silos from './silos'
import cardMetrics from './cardMetrics'
import breedCurves from './breedCurves'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    shared,
    auth,
    device,
    nucleus,
    nucleus2,
    property,
    alarms,
    readings,
    statistics,
    user,
    sex,
    device2,
    deviceLoginCookie,
    deviceModel,
    deviceRemoteAccessUrl,
    deviceType,
    country,
    state,
    city,
    wall,
    floor,
    roof,
    innerCurtain,
    outerCurtain,
    ownership,
    lining,
    evaporativePlate,
    lightingSystem,
    internetAccessType,
    barn,
    barnType,
    voltageType,
    airInlet,
    siloType,
    waterBox,
    watchdogSystem,
    batch,
    batchState,
    manufacturer,
    mortality,
    account,
    readings2,
    statistic2,
    inobramxPerformance,
    inobramxSetpoint,
    inobramxMaxMin,
    weightAnalysis,
    realtime,
    subscriptionDevices,
    version,
    alarmDashboard,
    activeAlarms,
    deviceFeatures,
    silos,
    cardMetrics,
    breedCurves
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js